import "../../styles/all.css";
import "./join.css";
import { useTranslation } from "react-i18next";

function Join() {
  const { t } = useTranslation();

  return (
    <>
      <div className="back" data-aos="fade-left">
        <div className="continerr">
          <h2>{t("join.title")}</h2>
          <h3>{t("join.subtitle")}</h3>
        </div>
      </div>
    </>
  );
}

export default Join;